// CYOC_ABI.js
import CYOC_c from "./contracts/CYOC_c.json";

const CYOC_c_ABI = CYOC_c.abi;
const CYOC_c_ADDRESS = '0x3084D29E98DDd6bca51c5abA6D41449e67E769b5';

export { CYOC_c_ABI, CYOC_c_ADDRESS };